import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * A report section that has not been built yet: skeleton lines plus a caption saying what will
 * eventually render there. The caption is the accessible content — the skeleton is decorative.
 */
@Component({
  selector: 'scr-report-placeholder',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './report-placeholder.html',
})
export class ReportPlaceholder {
  /** Line widths as percentages, conventionally decreasing. */
  readonly lineWidths = input<readonly number[]>([100, 94, 88, 62]);
  readonly caption = input.required<string>();
  readonly tagLabel = input<string>('Placeholder');
}
